import { render } from "./SelectTemplate.vue?vue&type=template&id=2b69e830&scoped=true"
import script from "./SelectTemplate.vue?vue&type=script&lang=js"
export * from "./SelectTemplate.vue?vue&type=script&lang=js"

import "./SelectTemplate.vue?vue&type=style&index=0&id=2b69e830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b69e830"]])

export default __exports__